import type { Memo } from '@memori-web/shared';
import { getDB } from './db.js';

export type StoredMemo = Memo & { dirty: boolean };

export async function putMemo(memo: Memo, opts: { dirty: boolean }): Promise<void> {
  const db = await getDB();
  await db.put('memos', { ...memo, dirty: opts.dirty });
}

export async function getMemo(id: string): Promise<StoredMemo | undefined> {
  const db = await getDB();
  return db.get('memos', id);
}

export async function listActiveMemos(): Promise<StoredMemo[]> {
  const db = await getDB();
  const all = await db.getAll('memos');
  return all
    .filter((m) => m.deletedAt === null)
    .sort((a, b) => (a.updatedAt < b.updatedAt ? 1 : -1));
}

export async function listDirtyMemos(): Promise<StoredMemo[]> {
  const db = await getDB();
  // by-dirty index stores boolean; query for true.
  // IDBKeyRange does not support boolean keys directly in some impls — use getAll then filter.
  const all = await db.getAll('memos');
  return all.filter((m) => m.dirty);
}

export async function markClean(id: string): Promise<void> {
  const db = await getDB();
  const tx = db.transaction('memos', 'readwrite');
  const existing = await tx.store.get(id);
  if (existing) {
    await tx.store.put({ ...existing, dirty: false });
  }
  await tx.done;
}
